module.exports = __webpack_public_path__ + "static/media/logo.7fa85b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 765
// module chunks = 0